module.exports = __webpack_public_path__ + "img/start.73289561.svg";